import React, { Component } from 'react';

import ReactDOM from 'react-dom';
import { T } from '../../../../common/locale/translate';

// Pass options_list = [ {name:, value:}, ... , {name:, value:} ]
// Pass title for label, class_name
//
// Pass function handleClick to get {name:, value:} from selected option
//
// Optional:
// allow folding on main input click: pass fold_on_input_click={true}
// allow folding when option is selected: pass close_on_select={true}

export default class UniversalSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_option_value: props.default_option
        ? props.default_option.value
        : T('choose_option'),
      current_option_name: props.default_option
        ? props.default_option.name
        : '',
      class_name: props.class_name || 'custom_select',
      title: props.title || 'Select',
      active: false,
      close_on_select: props.close_on_select || false,
      fold_on_input_click: props.fold_on_input_click || false
    };
    this.renderOptions = this.renderOptions.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);

    this.handleClose = this.handleClose.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleInputClick = this.handleInputClick.bind(this);
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => {
    const options = this.renderOptions();

    return (
      <div
        className={`${
          this.state.class_name
        } select-wrapper animated-text-form ${
          this.state.active ? 'active' : ''
        }`}
      >
        <label className="animated-text-label">
          <span className="animated-text-label-name">{this.state.title}</span>
        </label>
        <i className="dropdown-icon fa fa-chevron-down" />
        <input
          type="text"
          value={this.state.current_option_name}
          className="animated-text-input"
          placeholder=""
          onClick={this.handleInputClick}
          readOnly
        />
        <ul className="dropdown-menu">{options}</ul>
      </div>
    );
  };

  renderOptions = () => {
    let that = this;
    return this.props.options_list.map(function(option, index) {
      const isChecked = option.value == that.state.current_option_value;
      return (
        <li key={index} className={`item${isChecked ? ' active' : ''}`}>
          <input
            type="radio"
            id={`${that.state.class_name}-option-${option.value}`}
            onChange={that.handleOptionClick}
            data-value={option.value}
            data-name={option.name}
            checked={isChecked}
          />
          <label htmlFor={`${that.state.class_name}-option-${option.value}`}>
            {' '}
            {option.name}{' '}
          </label>
        </li>
      );
    });
  };

  handleOptionClick = event => {
    let selected_option = {
      name: event.currentTarget.dataset.name,
      value: event.currentTarget.dataset.value
    };

    this.props.handleChange(selected_option);
    this.setState({
      current_option_value: selected_option.value,
      current_option_name: selected_option.name,
      active: false
    });
  };

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({ active: false });
    }
  };

  handleClose = () => this.setState({ active: false });

  handleInputClick = () => {
    const activity = this.state.active;
    const is_folding_allowed = this.state.fold_on_input_click;
    if (is_folding_allowed) {
      this.setState({ active: !activity });
    } else {
      this.setState({ active: true });
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/universal_select.jsx